import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { colors } from "./theme";
/**
 * Color shortcut function, allows access to color property via `Theme.Color.primary100`
 */ var Color = colors.reduce(function(previousValue, key) {
    return _object_spread_props(_object_spread({}, previousValue), _define_property({}, key, function(param) {
        var theme = param.theme;
        var ref;
        return (ref = theme.color) === null || ref === void 0 ? void 0 : ref[key];
    }));
}, {});
export { Color };
